import { p as palette } from './color-DMp1DFwP.js';
import { l as list, a as link, t as typography } from './typography-j1qfCKl5.js';
import { s as shadow } from './shadow-DkIhu0PX.js';

// DO NOT USE
const globals = {
  bodyBackground: palette.concrete,
  bodyFontColor: typography.body.bodyFontColor,
  bodyFontFamily: typography.body.bodyFontFamily,
  bodyFontSize: typography.body.bodyFontSize,
  textDisabledColor: palette.boulder,
  textSecondaryColor: palette.emperor,
  textTertiaryColor: palette.boulder,
  radius: '3px',
  maxWidth: '1200px',
  boxShadowFocus: shadow.focus,
  boxShadowFocusInput: shadow.focusInput,
  link,
  list,
  // Applies to most disabled states
  disabled: `
    cursor: not-allowed;
    opacity: 0.5;
    outline: none;
  `
};

export { globals as g };
//# sourceMappingURL=globals-KScgLNUm.js.map
